<template>

  <card shadow class="card-profile b-2" style="width: 100%; color: black;" no-body>
    <div class="px-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h1 class="display-3 mt-3">Хичээлийн захиалгууд</h1>
        <div class="w-25">
          <input type="text" v-model="searchQuery" class="form-control"
            placeholder="Нэр, имэйл эсвэл хичээлээр хайх..." />
        </div>
      </div>

      <table class="table" v-if="filteredSubscriptions.length">
        <thead>
          <tr>
            <th>
              <button class="btn btn-link" @click="toggleSort">
                ID
                <i :class="sortDirection === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
              </button>
            </th>
            <th>Хэрэглэгчийн мэдээлэл</th>
            <th>Хичээл</th>
            <th>Захиалгын хугацаа</th>
            <th>Төлөв</th>
            <th>Төлбөр</th>
            <th class="text-right">Үйлдлүүд</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="subscription in filteredSubscriptions" :key="subscription.id">
            <td>{{ subscription.id }}</td>
            <td>
              <h4 class="display-4 mb-0">
                {{ subscription.firstname }} {{ subscription.lastname }}
              </h4>
              <span class="description">{{ subscription.email }}</span>
            </td>
            <td>{{ subscription.lesson_title }}</td>
            <td>
              <div class="small">
                Эхлэх: {{ formatDate(subscription.subscribed_at) }}<br>
                Дуусах: {{ formatDate(subscription.expires_at) }}
              </div>
            </td>
            <td>
              <span class="badge" :class="getStatusClass(subscription.status)">
                {{ getStatusTranslation(subscription.status) }}
              </span>
            </td>
            <td>
              <div class="text-left">
                <div>${{ subscription.amount }}</div>
                <span class="badge" :class="getPaymentStatusClass(subscription.payment_status)">
                  {{ getPaymentStatusTranslation(subscription.payment_status) }}
                </span>
              </div>
            </td>
            <td class="td-actions text-right">
              <button type="button" class="btn btn-info btn-icon btn-sm" @click="openEditModal(subscription)">
                <i class="fa fa-pencil pt-1"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="text-center py-4">
        <p class="h4 text-muted">Хайлтад тохирох захиалга олдсонгүй.</p>
      </div>
    </div>
    <Modal :show.sync="showModal" class="modalOverlay">
      <div class="modal-header">
        <h3>Захиалгыг засах</h3>
      </div>

      <form @submit.prevent="handleSubmit" class="modalForm">
        <div class="form-group">
          <label>Төлбөрийн төлөв</label>
          <select v-model="subscriptionData.payment_status" class="form-control">
            <option value="completed">Төлсөн</option>
            <option value="pending">Хүлээгдэж байна</option>
            <option value="failed">Амжилтгүй</option>
          </select>
        </div>

        <div class="modal-footer">
          <base-button type="link" class="cancelButton" @click="closeModal">
            Цуцлах
          </base-button>
          <base-button type="primary" class="saveButton" @click="handleSubmit">
            Өөрчлөлтийг хадгалах
          </base-button>
        </div>
      </form>
    </Modal>
  </card>

</template>

<script>
import axios from "axios";
import Modal from "@/components/Modal.vue";

export default {
  name: "LessonSubscriptions",
  components: {
    Modal,
  },
  data() {
    return {
      subscriptionList: [],
      subscriptionData: {
        id: null,
        status: "",
        payment_status: "",
        amount: 0,
      },
      showModal: false,
      searchQuery: "",
      sortDirection: "desc"
    };
  },
  created() {
    this.fetchSubscriptionList();
  },
  computed: {
    filteredSubscriptions() {
      let subscriptions = [...this.subscriptionList];

      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        subscriptions = subscriptions.filter(sub =>
          sub.email.toLowerCase().includes(query) ||
          `${sub.firstname} ${sub.lastname}`.toLowerCase().includes(query) ||
          sub.lesson_title.toLowerCase().includes(query)
        );
      }

      subscriptions.sort((a, b) => {
        if (this.sortDirection === 'asc') {
          return a.id - b.id;
        } else {
          return b.id - a.id;
        }
      });

      return subscriptions;
    }
  },
  methods: {
    fetchSubscriptionList() {
      axios
        .get("/payment_list")
        .then((response) => {
          this.subscriptionList = response.data;
        })
        .catch((error) => {
          console.error("Захиалгын жагсаалтыг татаж чадсангүй:", error);
        });
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString();
    },

    getStatusTranslation(status) {
      const translations = {
        active: 'Идэвхтэй',
        expired: 'Хугацаа дууссан',
        suspended: 'Түр зогсоосон'
      };
      return translations[status] || 'Тодорхойгүй';
    },

    getStatusClass(status) {
      const classes = {
        active: 'badge-success',
        expired: 'badge-danger',
        suspended: 'badge-warning'
      };
      return classes[status] || 'badge-secondary';
    },

    getPaymentStatusTranslation(status) {
      const translations = {
        completed: 'Төлсөн',
        pending: 'Хүлээгдэж байна',
        failed: 'Амжилтгүй'
      };
      return translations[status] || 'Тодорхойгүй';
    },

    getPaymentStatusClass(status) {
      const classes = {
        completed: 'badge-success',
        pending: 'badge-warning',
        failed: 'badge-danger'
      };
      return classes[status] || 'badge-secondary';
    },

    toggleSort() {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    },

    openEditModal(subscription) {
      this.subscriptionData = {
        id: subscription.id,
        payment_status: subscription.payment_status,
      };
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.subscriptionData = {
        payment_status: "",
      };
    },

    handleSubmit() {
      if (this.subscriptionData.id) {
        const data = {
          payment_status: this.subscriptionData.payment_status
        }
        axios
          .put(`/payment_list/${this.subscriptionData.id}`, data)
          .then(() => {
            this.fetchSubscriptionList();
            this.closeModal();
          })
          .catch((error) => {
            console.error("Илгээхэд алдаа гарлаа:", error);
          });
      }
    },
  },
};
</script>

<style scoped>
.btn-link {
  text-decoration: none;
  color: inherit;
  padding: 0;
}

.badge {
  padding: 0.5em 0.75em;
  border-radius: 0.25rem;
  font-size: 0.75em;
  font-weight: 600;
}
</style>
